import React from "react";

export const NEW = () => {
  return <sup style={{ color: "red", paddingLeft: "10px" }}>NEW!</sup>;
};
